import ReactLoading from "react-loading";

import "./index.scss";

const TableLoading = ({ isTable = true }: { isTable?: boolean }) => {
  if (isTable) {
    return (
      <tbody id="table-loading-container">
        <tr>
          <td colSpan={100}>
            <div>
              <ReactLoading
                type={"bubbles"}
                color={"#21f228"}
                width={window.innerHeight / 8}
              />
            </div>{" "}
            <p>{"درحال دریافت اطلاعات ..."}</p>
          </td>
        </tr>
      </tbody>
    );
  }
  return (
    <div className="loading-container">
      <div>
        <div>
          <ReactLoading
            type={"bubbles"}
            color={"#21f228"}
            width={window.innerHeight / 8}
          />
        </div>{" "}
        <p>{"درحال دریافت اطلاعات ..."}</p>
      </div>
    </div>
  );
};

export default TableLoading;
